<template>

<div class="report-list-wrapper">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="text" ref="search_term" v-model="filters.search_term" placeholder="Search..." @keyup.enter="getList(1)" v-focus>
			<div class="button action input-go" @click="getList(1)"><i class="fas fa-search"></i></div>
		</div>
		<label>{{ searchTip }}</label>
		<div class="controls">
			<pagination v-if="showPagination" :paging="paging" @updatePage="goToPage"></pagination>
			<button v-if="showDetail" class="action" @click="backToList()"><i class="fa fa-arrow-circle-left"></i> Back To List</button>
		</div>
	</div>

	<!-- <div class="close-filters" @click="showFilters = !showFilters" v-if="!showFilters">X</div> -->

	<div class="filters" v-if="showFilters">

		<div class="label-group">
			<label>Start</label>
			<input type="date" v-model="filters.start_date" :max="$today().clone().format('YYYY-MM-DD')" @change="getList(1)">
		</div>

		<div class="label-group">
			<label>End</label>
			<input type="date" v-model="filters.end_date" :max="$today().clone().format('YYYY-MM-DD')" @change="getList(1)">
		</div>

		<div class="label-group">
			<label></label>
			<ul class="checkbox-group">
				<li>
					<span :class="['pointer', 'far', filters.payment_date ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('payment_date')"></span>
					<label>Payment Date</label>
				</li>
				<li>
					<span :class="['pointer', 'far', filters.order_date ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('order_date')"></span>
					<label>Original Order Date</label>
				</li>
			</ul>
		</div>

		<div class="divider"></div>

		<ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.open ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('open')"></span>
				<label>Open Sales</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.closed ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('closed')"></span>
				<label>Completed Sales</label>
			</li>
		</ul>

		<div class="divider"></div>

		<div class="button action" @click="clearFilters(1)">Clear Filters</div>
		<div :class="['button', gettingExport ? 'disabled' : 'action']" @click="doExport()">Export CSV</div>
		<div class="message">{{ exportMessage }}</div>

	</div>

	<div v-if="filters.order_id">
		<div class="detail-title">
			<div class="title" v-html="orderDetail.description"></div>
			<div class="button action" @click="filters.order_id = ''"><i class="fa fa-arrow-circle-left"></i> Back To List</div>
		</div>
	</div>

	<div v-else class="list report-list">

	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>

	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list">Number</th>
					<th class="list">Date</th>
					<th class="list">Customer</th>
					<th class="list right">Total</th>
					<th class="list right">Payments</th>
					<th class="list right">Balance</th>
					<th class="list right">Last<br>Payment</th>
					<th class="list right">Report<br>Payments</th>
				</tr>
			</thead>
			<tr v-for="order in list" class="clickable-list-item" @click="getItem(order.order_id)">
				<td class="list">{{ order.order_number }}</td>
				<td class="list">{{ order.order_date }}</td>
				<td class="list">{{ order.customer }}</td>
				<td class="list right">{{ order.order_total }}</td>
				<td class="list right">{{ order.payments }}</td>
				<td class="list right">{{ order.balance_due }}</td>
				<td class="list right">{{ order.last_payment }}</td>
				<td class="list right">{{ order.payments_this_period }}</td>
			</tr>
		</table>

	</div>

	<iframe id="download" src="" style="display: none;"></iframe>

</div>

</template>

<script>
export default {
	name: 'report-list',
    components: {
    },
	data() {
		return {
            loading: true,
			searchTip: 'Search for an order by customer name.',
			page: 1,
			showPagination: false,
			showFilters: true,
			filters: {},
            default_start_date: '',
            default_end_date: '',
			filterMessage: '',
			filterLoading: false,
			definition: [],
			list: [],
			paging: {},
			showDetail: false,
			orderDetail: {},
			exportMessage: '',
			gettingExport: false
		}
	},
	created() {
		this.clearFilters(true)
	},
	methods: {
		clearFilters(getList) {
			this.filters = {
				page: 1,
				search_term: '',
				start_date: '',
				payment_date: false,
				order_date: false,
				end_date: '',
				order_id: '',
				do_export: false
			}

			var oneMonthAgo = new Date()

			oneMonthAgo.setMonth(oneMonthAgo.getMonth() -1)
			this.default_start_date = oneMonthAgo.toISOString().slice(0,10)
			this.default_end_date = new Date().toISOString().slice(0,10)
			this.filters.start_date = this.default_start_date
			this.filters.end_date = this.default_end_date

			if (getList) {
				this.getList(1)
			}
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.filters.page = 1
			this.getList()
		},
		getList(page) {
			this.loading = true
			this.apiCall({ destination: 'get_list_layaway_sales', data: this.filters }).then(obj => {
				this.loading = false
				if (this.filters.do_export) {
					this.filters.do_export = 0
					var outputFile = obj.file_name
					// accommodate live server filecache latency
					setTimeout(() => {
						document.getElementById("download").src = this.getDownloadEndpoint + "?file_name=" + obj.file_name + "&output_file_name=" + outputFile
						this.gettingExport = false
						this.exportMessage = ''
					}, 1500)
				} else {
					this.list = obj.list
				}
			}).catch(err => {
				console.log(err)
			})
		},
		getItem(orderId) {
			this.$router.push('/orders-sales/orders/detail/' + orderId)
		},
		doExport() {
			if (this.gettingExport) {
				return false
			}
			this.gettingExport = true
			this.exportMessage = 'Generating CSV for ' + this.list.length + ' items...'
			this.filters.order_id = ''
			this.filters.do_export = true
			this.getList(1)
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
